export const SMARTPHONE_LESSONS = [
  {
    id: 'smartphone-1',
    numero: 1,
    titre: "Prendre en main son smartphone",
    sousTitre: "Écran, boutons, gestes de base",
    contexte: "Marie vient de recevoir un smartphone en cadeau. Elle ne l'a jamais utilisé et ne sait pas par où commencer.",
    explication: [
      "Le **bouton latéral** (côté droit ou bas) sert à allumer/éteindre et verrouiller l'écran. Un appui court = verrouille. Appui long = éteindre.",
      "Pour **déverrouiller** : appuyez sur le bouton, puis faites glisser l'écran vers le haut (ou entrez votre code).",
      "Les gestes essentiels : **glisser le doigt** pour naviguer, **appuyer une fois** pour ouvrir, **appuyer longtemps** pour les options.",
      "Le **Wi-Fi** (symbole 📶) et les **données mobiles** (4G/5G) permettent d'accéder à Internet. Préférez le Wi-Fi à la maison — c'est gratuit.",
      "En cas de problème : maintenez le bouton latéral + volume bas 10 secondes pour **redémarrer** l'appareil.",
    ],
    question: "Comment accéder à Internet sans dépenser son forfait mobile ?",
    options: [
      { id: 'a', text: "En activant le Bluetooth", correct: false },
      { id: 'b', text: "En se connectant au Wi-Fi", correct: true },
      { id: 'c', text: "En redémarrant le téléphone", correct: false },
    ],
    explication_reponse: "Le Wi-Fi utilise votre connexion Internet à domicile — c'est inclus dans votre abonnement box. Les données mobiles, elles, consomment votre forfait.",
  },
  {
    id: 'smartphone-2',
    numero: 2,
    titre: "Téléphoner et envoyer des messages",
    sousTitre: "Appels, SMS, WhatsApp",
    contexte: "Marie veut appeler sa fille et lui envoyer une photo. Elle ne retrouve pas le bon bouton.",
    explication: [
      "Pour **appeler** : ouvrez l'application 'Téléphone' (icône combiné vert), tapez le numéro ou choisissez un contact, appuyez sur le bouton vert.",
      "Pour **raccrocher** : appuyez sur le bouton rouge. Pour couper le son pendant l'appel : appuyez sur l'icône micro.",
      "Les **SMS** s'envoient depuis l'application 'Messages' (bulle de conversation). Tapez votre texte et appuyez sur la flèche d'envoi.",
      "**WhatsApp** permet d'envoyer des messages, photos et vidéos **gratuitement** via Internet — très utile si votre forfait SMS est limité.",
      "Pour envoyer une **photo** : dans WhatsApp ou Messages, appuyez sur l'icône trombone 📎 ou appareil photo 📷.",
    ],
    question: "Quel est l'avantage de WhatsApp par rapport aux SMS classiques ?",
    options: [
      { id: 'a', text: "WhatsApp est plus rapide à taper", correct: false },
      { id: 'b', text: "WhatsApp fonctionne via Internet — messages et photos gratuits", correct: true },
      { id: 'c', text: "WhatsApp ne nécessite pas de numéro de téléphone", correct: false },
    ],
    explication_reponse: "WhatsApp utilise votre connexion Internet (Wi-Fi ou données). Vous pouvez envoyer des milliers de messages et photos sans frais supplémentaires.",
  },
  {
    id: 'smartphone-3',
    numero: 3,
    titre: "Installer et utiliser des applications",
    sousTitre: "Play Store, App Store, mises à jour",
    contexte: "Marie veut installer l'application de sa banque et Ameli. Elle ne sait pas comment faire.",
    explication: [
      "Les applications se téléchargent depuis le **Play Store** (Android, icône triangle coloré) ou l'**App Store** (iPhone, icône crayon bleu).",
      "Tapez le nom de l'application dans la barre de recherche. Vérifiez que c'est l'**application officielle** (logo reconnaissable, milliers d'avis).",
      "Appuyez sur **'Installer'** ou **'Obtenir'** — c'est gratuit pour la plupart des applications utiles. Ne donnez jamais votre numéro de carte.",
      "**Mettez à jour** vos applications régulièrement : Play Store → Mon profil → Gérer les applis → Tout mettre à jour.",
      "Si votre téléphone manque de place : supprimez les applications inutilisées (appui long sur l'icône → Désinstaller).",
    ],
    question: "Où télécharger des applications en toute sécurité sur un Android ?",
    options: [
      { id: 'a', text: "Sur n'importe quel site Internet", correct: false },
      { id: 'b', text: "Sur le Play Store officiel Google", correct: true },
      { id: 'c', text: "En recevant un lien par SMS", correct: false },
    ],
    explication_reponse: "Le Play Store (Android) et l'App Store (iPhone) vérifient les applications avant publication. Télécharger depuis un lien SMS ou un site inconnu est dangereux.",
  },
  {
    id: 'smartphone-4',
    numero: 4,
    titre: "Sécurité et bonnes habitudes",
    sousTitre: "Code, mises à jour, arnaques",
    contexte: "Marie a reçu un SMS lui disant que son colis est bloqué et qu'elle doit cliquer sur un lien. Elle ne sait pas si c'est une arnaque.",
    explication: [
      "**Activez un code PIN ou une empreinte digitale** pour verrouiller votre téléphone — indispensable en cas de perte ou vol.",
      "Ne cliquez **jamais sur un lien reçu par SMS** vous demandant un paiement ou vos identifiants — c'est presque toujours une arnaque (smishing).",
      "**Mettez à jour votre téléphone** régulièrement (Paramètres → Système → Mise à jour) — cela corrige les failles de sécurité.",
      "Sur le Wi-Fi public (café, gare), **évitez de consulter votre banque** — les connexions peuvent être interceptées.",
      "En cas de doute sur un message ou une application, appelez directement l'organisme concerné via son numéro officiel.",
    ],
    question: "Vous recevez un SMS avec un lien pour 'libérer votre colis contre 2 €'. Que faites-vous ?",
    options: [
      { id: 'a', text: "Vous cliquez et payez — c'est une petite somme", correct: false },
      { id: 'b', text: "Vous ignorez ou supprimez le SMS — c'est une arnaque classique", correct: true },
      { id: 'c', text: "Vous transmettez le lien à vos contacts pour les prévenir", correct: false },
    ],
    explication_reponse: "Les arnaques aux faux colis (smishing) sont très répandues. Les vrais transporteurs ne demandent jamais de paiement par SMS. Signalez sur signal-spam.fr.",
  },
];
